module.exports = __webpack_public_path__ + "static/john-white.79e9ff7f.webp";